module.exports = __webpack_public_path__ + "static/media/map-marker-path.10c1beec.png";